import ACTIONS from './index';
import axios from '../../utils/axios';

// ─────────────────────────────────────
// GET ALL ROOMS
// ─────────────────────────────────────
export const getAllRooms =
  (page = 1, filter = 'all', search = '') =>
  async (dispatch) => {
    try {
      dispatch({ type: ACTIONS.GET_ALL_ROOMS_REQUEST });

      const res = await axios.get(
        `/api/chatroom/all?page=${page}&limit=300&filters=${filter}&search=${search}`,
      );

      dispatch({
        type: ACTIONS.GET_ALL_ROOMS_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: ACTIONS.GET_ALL_ROOMS_FAIL,
        payload: error?.response?.data?.message || error.message,
      });
    }
  };

// ─────────────────────────────────────
// GET THREADS BY PROSPECT
// ─────────────────────────────────────
export const getThreads =
  (prospectId, activeProspect, readStatus, page = 1) =>
  async (dispatch) => {
    try {
      dispatch({ type: ACTIONS.GET_THREADS_REQUEST });

      const res = await axios.get(
        `/api/threads/threads-history/${prospectId}?readStatus=${readStatus}&page=${page}&limit=100`,
      );

      dispatch({
        type: ACTIONS.GET_THREADS_SUCCESS,
        payload: res.data,
        activeProspect,
      });
    } catch (error) {
      dispatch({
        type: ACTIONS.GET_THREADS_FAIL,
        payload: error?.response?.data?.message || error.message,
      });
    }
  };

// ─────────────────────────────────────
// SEND MESSAGE
// ─────────────────────────────────────
export const sendMessage = (prospectId, to, text) => async (dispatch) => {
  try {
    dispatch({ type: ACTIONS.SEND_MESSAGE_REQUEST });

    const res = await axios.post(`/api/threads/new-thread`, {
      prospectId,
      to,
      text,
    });

    dispatch({
      type: ACTIONS.SEND_MESSAGE_SUCCESS,
      payload: res.data.data, // { room, threads, results }
    });
  } catch (error) {
    dispatch({
      type: ACTIONS.SEND_MESSAGE_FAIL,
      payload: error?.response?.data?.message || error.message,
    });
  }
};

// ─────────────────────────────────────
// SET ACTIVE PROSPECT (when opening/switching chat)
// ─────────────────────────────────────
export const setActiveProspect = (prospect) => (dispatch) => {
  const newRoom = {
    from: prospect.phoneInfo[0],
    to: {},
    _id: '1',
    prospectId: prospect,
    createdAt: new Date(),
    direction: 'outbound',
    isDeleted: false,
    recievedAt: '',
    resuourceId: prospect.resuourceId,
    updatedAt: new Date(),
  };

  dispatch({
    type: ACTIONS.SET_ACTIVE_PROSPECT,
    payload: { prospect, newRoom },
  });
};
